<template>
  <div class="test" @scroll="onScroll" ref="scrollContainer" style="max-height: 750px; overflow-y: auto;">
    <v-data-table no-data-text="데이터가 없습니다." :headers="headers" :items="items" item-key="item.order" class="data-table" :loading="isLoading"
      hide-default-footer :items-per-page="25" :disabled="isLoading">
      <template>
        
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td>
            <div class="image-container ma-1">
              <v-img :src="item.image" class="datatable_thumnail" :contain="true" />
            </div>
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.runtime }}</td>
          <td>{{ item.delete }}</td>
        </tr>
      </template>
      <template v-slot:body="{ items }">
        <draggable :list="items" tag="tbody" @change="handleDrag">

          <template v-if="!items.length">
            <tr style="text-align: center;">
              <td colspan="4">
                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;padding: 200px;">
                  <img src="@/styles/error_nodata.png" width="170px"/>
                  <p class="mt-4" style="color: #888;" >
                    {{ $store.getters.t('데이터가 없습니다.') }} <br>
                    {{ $store.getters.t('데이터를 추가해주세요.') }}
                  </p>
                </div>
              </td>
            </tr>
          </template>

          <template v-else>
            <tr v-for="(item) in items" :key="`page-${currentPage}-item-${item.order}`">
              <td style="width: 10%;">
                <div class="image-container ma-1">
                  <v-img :src="item.image" class="datatable_thumnail" :contain="true" />
                </div>
              </td>
              <td style="width: 70%;">{{ item.name }}</td>
              <td style="width: 10%;">{{ item.runtime }}</td>
              <td>
                <v-btn icon @click="deleteItem(item.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
        </template>
        </draggable>
      </template>
    </v-data-table>

    <v-progress-circular v-if="isLoading" indeterminate color="primary"></v-progress-circular>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import draggable from 'vuedraggable'
import PlaylistApi from "@/api/playlist/PlaylistApi";


export default {
  components: {
    draggable,
  },
  props: {
    groupId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      // headers: [
      //   { text: this.$store.getters.t('썸네일'), value: 'image' },
      //   { text: this.$store.getters.t('파일 이름'), value: 'name' },
      //   { text: this.$store.getters.t('재생 시간'), value: 'runtime' },
      //   { text: this.$store.getters.t('삭제'), value: 'delete' },
      // ],
      page: 0,
      pageSize: 10,
      // image: item.image ? require(`@/styles/${item.image}`) : require('@/styles/test logo.png'),
      items: [],
      isLoading: false,
      cachedPlaylists: {},
      currentPage: 1,
      totalItems: 0,
      tracks: {
        current_page: 1,
        next_page_url: null,
        last_page: 1,
        data: []
      },
    };
  },
  mounted() {
    
    //this.fetchPlaylist(this.groupId, true);
  },
  methods: {
    ...mapActions('group', ['updateSelectedGroupId', 'updateSelectedGroupName']),
    onScroll() {
      const { scrollTop, scrollHeight, clientHeight } = this.$refs.scrollContainer;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.fetchMoreItems();
      }
    },
    async handleDrag(event) {
      //console.log('event', event);
      let oldOrder = event.moved.oldIndex + 1;
      let newOrder = event.moved.newIndex + 1;
      const data = {
        order: oldOrder,
        newOrder: newOrder
      };
      try {
        const response = await PlaylistApi.playlistDrag(data);
        //console.log('response', response);
      } catch (error) {
        console.error("error", error);
      }
    },
    async fetchPlaylist(page = 1, forceUpdate = false, groupId = this.groupId) {
      //console.log('groupid', this.groupId);
      //const groupId = this.groupId;
      const cacheKey = `${groupId}-${page}`;

      if (forceUpdate || !this.cachedPlaylists[cacheKey]) {
        try {
          const response = await PlaylistApi.playListApi(groupId, page);
          //console.log('response', response);
          const processedData = response.tracks.data.map(item => ({
            id: item.id,
            name: item.asset.name,
            runtime: item.asset.runtime,
            order: item.order,
            image: item.asset.posterImg  ? item.asset.posterImg : "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png",
          }));
          this.totalItems = response.tracks.total;
          this.items = processedData;
          this.cachedPlaylists[cacheKey] = this.items;
          this.tracks = {
            current_page: response.tracks.current_page,
            next_page_url: response.tracks.next_page_url,
            last_page: response.tracks.last_page,
            data: this.items
          };
        } catch (error) {
          console.error("error", error);
        }
      } else {
        this.items = this.cachedPlaylists[cacheKey];
      }
    },
    async fetchMoreItems() {
      if (this.isLoading || !this.tracks.next_page_url || this.current_page >= this.last_page) return;
      this.isLoading = true;

      const nextPage = this.tracks.current_page + 1;

      try {
        const response = await PlaylistApi.playListApi(this.groupId, nextPage);
        const newTracks = response.tracks.data.map(item => ({
          id: item.id,
          name: item.asset.name,
          runtime: item.asset.runtime,
          order: item.order,
          image: item.asset.posterImg  ? item.asset.posterImg  : "",
        }));

        this.items = [...this.items, ...newTracks];
        this.tracks = {
          ...this.tracks,
          current_page: response.tracks.current_page,
          next_page_url: response.tracks.next_page_url,
          last_page: response.tracks.last_page
        };
      } catch (error) {
        console.error("error", error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem(id) {
      const data = {
        itemId: id,
        groupId: this.groupId
      };
      //console.log('data', data)
      const response = await PlaylistApi.deletePlaylistItem(data);
      if(response.status === 1){
        await this.fetchPlaylist(this.currentPage, true, this.groupId);
      }
    },
    forceRefresh() {
      this.fetchPlaylist(this.currentPage, 10);
    },
  },
  computed: {
    // groupId() {
    //   return this.$store.state.group.selectedGroupId;
    // },
    groupingCompleted() {
      return this.$store.state.group.groupingCompleted;
    },
    headers(){
      return [
        { text: this.$store.getters.t('썸네일'), value: 'image' },
        { text: this.$store.getters.t('파일 이름'), value: 'name' },
        { text: this.$store.getters.t('재생 시간'), value: 'runtime' },
        { text: this.$store.getters.t('삭제'), value: 'delete' },
      ];
    },
  },
  watch: {
    groupingCompleted(newValue) {
      if (newValue === true) {
        this.fetchPlaylist(this.currentPage, true, this.groupId);
      }
    },
    async groupId(newValue, oldValue) {
      if (newValue !== oldValue && !isNaN(parseFloat(newValue))) {
        await this.fetchPlaylist(this.currentPage, true, this.groupId);
      }
    },
  },



}
</script>

<style lang="scss" scoped></style>